import React, { Component } from 'react';
import { Layout } from 'antd';

const { Footer } = Layout;

class AppFooter extends Component {
    render() {
        return(
            <Footer style={{ textAlign: 'center', backgroundColor: 'rgb(171,211,186)', fontSize: '15px', fontFamily: 'Corbel' }}>
                © Redtomato Design Studio 2018
            </Footer>
        );
    }
}

export default AppFooter;



// WEBPACK FOOTER //
// ./src/components/base_layout/AppFooter.js